var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/DependencyTree/model/buildIdVersionKey.ts";
import "core-js/modules/es.array.concat.js";
export function buildIdVersionKey(_ref) {
  var id = _ref.id,
      version = _ref.version;
  return "".concat(id, ":").concat(version);
}